import React from "react";
import ReactMarkdown from "react-markdown";
import Styles from "./Styles.module.scss";

declare interface IMarkdownContent {
    source: string;
}

const MarkdownContent: React.FC<IMarkdownContent> = ({ source }) => {
    return (
        <ReactMarkdown className={Styles.markdownContentWidget}>
            {source}
        </ReactMarkdown>
    );
};

export default MarkdownContent;
